import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { SettingsFormFooter } from '@/containers/Settings/SettingsLayout'
import API from '@/lib/api'

const schema = z.object({
  name: z.string(),
})

type AccountFormData = z.infer<typeof schema>

export function AccountForm({
  defaultValues,
}: {
  defaultValues?: AccountFormData
}) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'settings',
  })

  const form = useForm<AccountFormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      name: defaultValues?.name || '',
    },
  })

  const onSubmit = (data: AccountFormData) =>
    API.patch('/api/v2/settings', {
      name: data.name,
    })
      .then(() => {
        toast.success(t('invoicing.generic.success'))
        form.reset(data)
      })
      .catch(() => {
        toast.error('Název účtu se nepodařilo uložit.')
      })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="sr-only">{t('account.name.label')}</FormLabel>
              <FormControl>
                <Input {...field} placeholder={t('account.name.placeholder')} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <SettingsFormFooter>
          <Button type="submit" disabled={form.formState.isSubmitting}>
            {form.formState.isSubmitting ? 'Ukládám' : 'Uložit'}
          </Button>
        </SettingsFormFooter>
      </form>
    </Form>
  )
}
